import React from 'react'
import { HighlightCard, HighlightCardsWrapper } from 'ui'
import { Translation } from '@morningtrain/react-translations'
import * as Displays from 'support/displays'

export default function EntriesHighlight ({ backgroundColor }) {
  return (
    <HighlightCardsWrapper>
      <HighlightCard
        backgroundColor={backgroundColor}
        title={<Translation name='highlight_cards.vacation_days' />}
        content={<Displays.Integer name='vacationDays' />}
      />
      <HighlightCard
        backgroundColor={backgroundColor}
        title={<Translation name='highlight_cards.normal_hours' />}
        content={<Displays.Number name='totalNormalDuration' />}
      />
      <HighlightCard
        backgroundColor={backgroundColor}
        title={<Translation name='highlight_cards.admin_hours' />}
        content={<Displays.Number name='totalAdminDuration' />}
      />
      <HighlightCard
        backgroundColor={backgroundColor}
        title={<Translation name='highlight_cards.total_hours' />}
        content={<Displays.Number name='totalDuration' />}
      />
      <HighlightCard
        backgroundColor={backgroundColor}
        title={<Translation name='highlight_cards.total_shifts' />}
        content={<Displays.Integer name='totalShifts' />}
      />
    </HighlightCardsWrapper>
  )
}
